import React, {FC} from "react";
import {
    Snackbar,
    Button,
    Alert,
    SnackbarCloseReason,
    AlertColor,
} from "@mui/material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";

interface CustomSnackbarProps {
    open: boolean;
    message: React.ReactNode;
    onClose: () => void;
    actionLocaId?: IdlocaGeneric;
    onActionClick?: () => void;
    severity: AlertColor;
}

export const CustomSnackbar: FC<CustomSnackbarProps> = ({
    open,
    message,
    onClose,
    actionLocaId,
    onActionClick,
    severity,
}) => {
    const handleClose = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === "clickaway") {
            return;
        }
        onClose();
    };

    // TODO use theme colors
    return (
        <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
            <Alert
                onClose={handleClose}
                severity={severity}
                variant="filled"
                sx={{
                    width: "100%",
                    backgroundColor: "rgba(0,110,14,0.6)",
                    color: "#fff",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    display: "flex",
                    alignItems: "center",
                }}
                action={
                    <>
                        {actionLocaId && (
                            <Button
                                color="secondary"
                                size="small"
                                onClick={onActionClick}
                                sx={{
                                    textTransform: "none",
                                    color: "rgb(255,255,255)",
                                    backgroundColor: "rgba(0,110,14,0.7)",
                                    "&:hover": {
                                        backgroundColor: "rgb(0,30,12)",
                                    },
                                    padding: "6px 12px",
                                    marginRight: "10px",
                                }}
                            >
                                <Locale localeId={actionLocaId}/>
                            </Button>
                        )}
                        <Button
                            color="inherit"
                            size="small"
                            onClick={handleClose}
                            sx={{
                                color: "rgb(255,255,255)",
                                backgroundColor: "rgba(0,110,14,0.7)",
                                "&:hover": {
                                    backgroundColor: "rgb(0,30,12)",
                                },
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                minWidth: 0,
                                padding: 0,
                            }}
                        >
                            X
                        </Button>
                    </>
                }
            >
                {message}
            </Alert>
        </Snackbar>
    );
};
